// extracted by mini-css-extract-plugin
export default {"brandPromo":"JE-z","carousel":"KE-z"};